module.exports = __webpack_public_path__ + "static/media/291720.066ff1d8.png";